import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品服务',
    links: [
      { label: '综合服务', path: '/category/zonghe-fuwu' },
      { label: '技术支持', path: '/category/jishu-zhichi' },
      { label: '产品动态', path: '/category/chanpin-dongtai' },
    ],
  },
  company: {
    title: '关于 aqdlt',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '商务合作', path: '/category/shangwu-hezuo' },
      { label: '成功案例', path: '/category/chenggong-anli' },
    ],
  },
  resources: {
    title: '资源中心',
    links: [
      { label: '行业资讯', path: '/category/xingye-zixun' },
      { label: '帮助文档', path: '/category/zonghe-fuwu' },
      { label: '联系我们', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4 cursor-pointer">
                <span className="text-2xl font-heading font-bold text-background-50">aqdlt</span>
              </Link>
              <p className="text-sm leading-relaxed text-background-50/60 max-w-xs">
                aqdlt 是您值得信赖的专业平台，提供全方位的数字化服务与解决方案，助力企业高效发展。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm text-background-50/80"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm text-background-50/80"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer">
                  <i className="ri-linkedin-line text-sm text-background-50/80"></i>
                </span>
              </div>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h4>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-background-50/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} aqdlt. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}